import { Box, Divider, Grid, Typography } from "@mui/material";
import DashboardBarChart from "./DashboardBarChart";
import DashboardTabContainer from "./DashboardTabContainer";
import DashboardHeroCard from "./DashboardHeroCard";
import DashboardMiniStatsBarChart from "./DashboardMiniStatsBarChart";
import DashboardStatsTable from "./DashboardStatsTable";
import {
  BCPCalendarDays,
  BCPChartMixed,
  BCPDiceD20,
  BCPFlag,
  BCPUserGroup,
  BCPUsersBetweenLines,
  BCPListOl,
  BCPCircle1,
  BCPCircle2
} from "../../../components/icons/bcp/BCPIcons";
import DashboardScatterChart from "./DashboardScatterChart";
import DashboardHeroCardPercentage from "./DashboardHeroCardPercentage";
import DashboardIconChart from "./DashboardIconChart";
import DashboardLineBarChart from "./DashboardLineBarChart";

export function DashboardIcon(icon) {
  if (!icon) return null;
  return icon === "UserGroup"
    ? BCPUserGroup
    : icon === "Flag"
      ? BCPFlag
      : icon === "UsersBetweenLines"
        ? BCPUsersBetweenLines
        : icon === "CalendarDays"
          ? BCPCalendarDays
          : icon === "ChartMixed"
            ? BCPChartMixed
            : icon === "List01"
              ? BCPListOl
              : icon === 1
                ? BCPCircle1
                : icon === 2
                  ? BCPCircle2
                  : BCPDiceD20;
}

export function DashboardElement(props) {
  const { componentType, sx, eventName } = props;
  if (componentType === "Header")
    return (
      <Typography
        variant={props?.variant || "h5"}
        sx={{
          mb: 3,
          color: "primary",
          fontWeight: 600,
          textAlign: "center",
          letterSpacing: { xs: "0.05em", sm: "0.1em" },
          textTransform: "uppercase",
          pt: 2,
          ...sx
        }}
      >
        {props?.label}
      </Typography>
    );

  if (componentType === "Divider")
    return (
      <Divider
        sx={{ mx: { xs: "-10%", sm: "-6%", md: -3 }, ...sx }}
      />
    );

  if (componentType === "HeroCard") return <DashboardHeroCard {...props} />;
  if (componentType === "HeroCardPercentage")
    return <DashboardHeroCardPercentage {...props} />;

  if (componentType === "BarChart")
    return (
      <DashboardBarChart
        label={props?.label}
        data={props?.data}
        eventName={eventName}
      />
    );

  /* replace with dynamic chart from the OverallStats.js */

  if (componentType === "MiniStatsBarChart")
    return (
      <DashboardMiniStatsBarChart label={props?.label} data={props?.data} />
    );
  if (componentType === "StatsTable")
    return <DashboardStatsTable label={props?.label} data={props?.data} />;
  if (componentType === "ScatterChart")
    return <DashboardScatterChart label={props?.label} data={props?.data} />;
  if (componentType === "IconChart")
    return <DashboardIconChart label={props?.label} data={props?.data} />;
  if (componentType === "LineBarChart")
    return <DashboardLineBarChart label={props?.label} data={props?.data} />;
  if (componentType === "TabContainer")
    return (
      <DashboardTabContainer
        label={props?.label}
        tabs={props?.tabs}
        eventName={eventName}
      />
    );
}

export default function DashboardBuilder({ rows, eventName }) {
  return (
    <Box
      sx={{
        pt: 2,
        pb: 2
      }}
    >
      {rows?.map((row, i) => (
        <Grid
          key={`rows-${i}`}
          container
          spacing={2}
          sx={{
            pb: 2
          }}
        >
        {row?.cols?.map((col) => {
          const isHeroCard =
            col.componentType === "HeroCard" ||
            col.componentType === "HeroCardPercentage";
          const sm = col.sm ?? (isHeroCard ? 6 : undefined);
          return (
            <Grid key={`cols-${i}`} item xs={col.xs || 12} sm={sm} md={col.md}>
              <DashboardElement {...col} eventName={eventName} />
            </Grid>
          );
        })}
        </Grid>
      ))}
    </Box>
  );
}
